import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { mainApiUrl, baseHeaders } from '@constants'
import { prepareHeaders } from '@src/reduxjs'

const localsApi = createApi({
  reducerPath: 'localsApi',
  baseQuery: fetchBaseQuery({ baseUrl: mainApiUrl, prepareHeaders }),
  tagTypes: ['Locals', 'CurrentStore'],
  endpoints: (builder) => ({
    get: builder.query({
      query: (data = {}) => {
        const params = {}

        if (data.page) {
          params.page = data.page
        }

        if (data.perPage) {
          params.per_page = data.perPage
        }

        return { url: 'locals', params }
      },
      providesTags: (results) => {
        if (!results) {
          return [{ type: 'Locals', id: 'LIST' }]
        }
        return []
      },
    }),
    getOne: builder.query({
      query: (local_id) => ({ url: `locals/${local_id}`, method: 'GET' }),
      invalidatesTags: (results, error, { id }) => {
        return [{ type: 'Locals', id }]
      },
    }),
  }),
})

export const { useGetQuery, useGetOneQuery } = localsApi

export default localsApi
